import {
  ENCARGOS_ADD_ARTICLE_FROM_ENCARGO,
  ENCARGOS_REMOVE_ARTICLE_FROM_ENCARGO,
  ENCARGOS_SET_WORKSPACE,
  ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_REQUEST,
  ENCARGOS_SET_LOADING,
  ENCARGOS_CREAR_PRESUPUESTO_RAPIDO,
  ENCARGOS_MARCAR_ARTICULOS,
  ENCARGOS_DEVOLVER_ARTICULOS_REQUEST,
  ENCARGOS_DEVOLVER_ARTICULOS_SUCCESS,
  ENCARGOS_COBRAR_REQUEST, ENCARGOS_SELECCIONAR_LINEA
} from '../constants/encargos.constants';

export const addArticleToEncargo = ({ articulo, encargoId, append }) => ({
  type: ENCARGOS_ADD_ARTICLE_FROM_ENCARGO,
  payload: { articulo, encargoId, append },
});

export const eliminarArticuloDeEncargo = ({ encargoId, articulo }) => ({
  type: ENCARGOS_REMOVE_ARTICLE_FROM_ENCARGO,
  payload: { encargoId, articulo },
});

export const fetchEncargoAndLoadIntoWorkspace = (encargoId, tiendaId) => ({
  type: ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_REQUEST,
  payload: { encargoId, tiendaId },
});

export const setEncargosWorkspace = payload => ({
  type: ENCARGOS_SET_WORKSPACE,
  payload: {
    ...payload,
  },
});

export const setWorkspaceLoading = ({ loading = true }) => ({
  type: ENCARGOS_SET_LOADING,
  payload: { loading },
});

export const crearPresupuestoRapido = payload => ({
  type: ENCARGOS_CREAR_PRESUPUESTO_RAPIDO,
  payload,
});

export const marcarArticulosDeEncargo = ({
  encargo, articulos, agrupacionId, value,
}) => ({
  type: ENCARGOS_MARCAR_ARTICULOS,
  payload: ({
    encargo, articulos, agrupacionId, value,
  }),
});

export const devolverArticuloDeEncargo = payload => ({
  type: ENCARGOS_DEVOLVER_ARTICULOS_REQUEST,
  payload,
});

export const devolverArticuloDeEncargoSuccess = payload => ({
  type: ENCARGOS_DEVOLVER_ARTICULOS_SUCCESS,
  payload,
});

export const cobrarEncargosRequest = payload => ({
  type: ENCARGOS_COBRAR_REQUEST,
  payload,
});
export const selectEncargoLinea = payload => ({
  type: ENCARGOS_SELECCIONAR_LINEA,
  payload,
});
